import React from 'react';
import SectionHeader from '@apricityhealth/web-common-lib/components/headers/SectionHeader';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';

export default ({title, subtitle, color, ...rest}) => {
    return (
        <SectionHeader
            color={color}
            title={title}
            subtitle={subtitle}
            icon={<PlaylistAddIcon style={{ color}}/>}
            {...rest}
        />
    );
}

